// src/pages/analytics/ReturnIndexPage/columns.js
import React from 'react';
import { Typography, Progress, Tooltip, Space } from 'antd';
import { StarFilled, InfoCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

/**
 * @param {Function} onNameClick - La fonction callback pour ouvrir la modale
 */
export const returnIndexTableColumns = (onNameClick) => [
    {
        title: 'Médecin',
        dataIndex: 'physicianId',
        key: 'physicianName',
        width: 220,
        fixed: 'left',
        render: (text, record) => { 
            const firstName = record.physicianFirstName || '';
            const lastName = record.physicianLastName || '';
            const fullName = `${firstName} ${lastName}`.trim() || `ID: ${record.physicianId}`;
            const isPartner = record.isPartner;
            
            return (
                <Space>
                    {/* ÉTOILE SI PARTENAIRE */}
                    {isPartner && (
                        <Tooltip title={record.partnerNotes || "Médecin Partenaire"}>
                            <StarFilled style={{ color: '#fadb14', fontSize: '16px' }} />
                        </Tooltip>
                    )}
                    <a onClick={() => onNameClick(record.physicianId)}>
                        <Text strong style={{ 
                            color: isPartner ? '#856404' : '#1890ff', // Marron/Or si partenaire
                            textDecoration: 'underline', 
                            cursor: 'pointer' 
                        }}>
                            {fullName}
                        </Text>
                    </a>
                </Space>
            );
        },
        sorter: (a, b) => { 
            const nameA = `${a.physicianFirstName || ''} ${a.physicianLastName || ''}`.trim().toLowerCase();
            const nameB = `${b.physicianFirstName || ''} ${b.physicianLastName || ''}`.trim().toLowerCase();
            return nameA.localeCompare(nameB);
        },
    },
    {
        title: 'Spécialité',
        dataIndex: 'specialtyName',
        key: 'specialtyName',
        width: 180,
        render: (text) => text || <Text type="secondary">N/A</Text>,
        sorter: (a, b) => (a.specialtyName || '').localeCompare(b.specialtyName || ''),
    },
    {
        title: 'Région',
        dataIndex: 'regionName',
        key: 'regionName',
        width: 150,
        render: (text) => text || <Text type="secondary">N/A</Text>, 
        sorter: (a, b) => (a.regionName || '').localeCompare(b.regionName || ''),
    },
    {
        title: (
            <Tooltip title="Nombre de cycles où le médecin était une cible pour le délégué pendant la période sélectionnée.">
                Cible (Cycles) <InfoCircleOutlined />
            </Tooltip>
        ),
        dataIndex: 'timesTargetedInCycles',
        key: 'timesTargetedInCycles',
        align: 'center',
        width: 150,
        sorter: (a, b) => (a.timesTargetedInCycles ?? 0) - (b.timesTargetedInCycles ?? 0),
        render: (text) => text != null ? text : 0, 
    },
    {
        title: (
            <Tooltip title="Nombre de visites effectives rapportées par le délégué pour ce médecin sur la période.">
                Visites Effectives <InfoCircleOutlined />
            </Tooltip>
        ),
        dataIndex: 'effectiveVisitsReported',
        key: 'effectiveVisitsReported',
        align: 'center',
        width: 150,
        sorter: (a, b) => (a.effectiveVisitsReported ?? 0) - (b.effectiveVisitsReported ?? 0),
        render: (text) => text != null ? text : 0, 
    },
    {
        title: (
            <Tooltip title="Taux de réalisation : (Visites Effectives / Fois Cible) * 100">
                Indice Retour (%) <InfoCircleOutlined />
            </Tooltip>
        ),
        dataIndex: 'returnIndex',
        key: 'returnIndex',
        align: 'center',
        width: 200,
        sorter: (a, b) => (a.returnIndex ?? -1) - (b.returnIndex ?? -1),
        render: (percentage) => { 
            if (percentage === null || percentage === undefined) {
                return <Text type="secondary">N/A</Text>;
            }
            const percentValue = parseFloat(percentage.toFixed(1));
            let progressBarColor;
            let status = 'normal'; 
            if (percentValue < 66) {
                progressBarColor = '#ff4d4f'; status = 'exception';
            } else if (percentValue < 75) {
                progressBarColor = '#1677ff'; status = 'normal';
            } else {
                progressBarColor = '#52c41a'; status = 'success';
            }
            return (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Progress
                        percent={percentValue}
                        status={status}
                        strokeColor={progressBarColor}
                        showInfo={false}
                        style={{ flexGrow: 1, marginRight: 8 }}
                    />
                    <Text style={{ color: progressBarColor, fontWeight: 'bold', minWidth: '45px', textAlign: 'right' }}>
                        {percentValue}%
                    </Text>
                </div>
            );
        },
    },
];